/**
 * App-wide display date format: "29 Oct 2026" (en-GB short month).
 * Parses YYYY-MM-DD as a local calendar date to avoid UTC day shifts.
 */

const DISPLAY_OPTS = { day: 'numeric', month: 'short', year: 'numeric' };
const SHORT_OPTS = { day: 'numeric', month: 'short' };

function toLocalDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
    const [y, m, day] = value.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, day);
  }
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatDisplayDate(value) {
  const d = toLocalDate(value);
  if (!d) return value ? String(value) : '—';
  return d.toLocaleDateString('en-GB', DISPLAY_OPTS);
}

/** Chart axis labels without year (e.g. "29 Oct"). */
export function formatShortDate(value) {
  const d = toLocalDate(value);
  if (!d) return value ? String(value) : '—';
  return d.toLocaleDateString('en-GB', SHORT_OPTS);
}

export function todayIsoDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
